



















import Vue from 'vue'
// import WordmarkLogo from './images/WordmarkLogo.vue'
import AuthNav from './Auth/AuthNav.vue'

export default Vue.extend({
  name: 'App',

  components: {
    // WordmarkLogo,
    AuthNav
  },

  data: () => ({
    //
  })
})
